import { Suspense } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import MobileNav from "./MobileNav";
import BookSpinner from "@/components/common/BookSpinner";
import CommandPalette from "@/components/common/CommandPalette";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}

export default function MainLayout() {
  return (
    <div className="relative flex min-h-screen flex-col">
      <ScrollToTop />

      {/* Sticky Header */}
      <Header />

      {/* Main Content Area */}
      <main className="flex-1">
        <div className="mx-auto w-full max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
          <Suspense
            fallback={
              <div className="flex min-h-[60vh] items-center justify-center">
                <BookSpinner />
              </div>
            }
          >
            <Outlet />
          </Suspense>
        </div>
      </main>

      {/* Footer */}
      <Footer />

      {/* Mobile bottom navigation (visible on small screens only) */}
      <MobileNav />

      {/* Global command palette (Ctrl+K / Cmd+K) */}
      <CommandPalette />

      {/* Mobile safe-area spacer */}
      <div className="h-safe-bottom md:hidden" />
    </div>
  );
}
